import React from 'react';
import PurchaseOrderViewInfoEntry from './PurchaseOrderViewInfoEntry';

import {
  CapaQuotationRfqPurchaseOrder,
  CapaQuotationServiceType,
  CapaRfqPurchaseOrderTransferTermsType
} from '@generated/graphql';

import { CustomizedTypography } from '@components/Customized';

import useStyles from './useStyles';

interface Props {
  renderDivider: () => React.ReactNode;
  serviceType?: CapaQuotationServiceType;
  currentItem?: CapaQuotationRfqPurchaseOrder;
}

const PurchaseOrderMoldTransferInfo = ({
  currentItem,
  serviceType,
  renderDivider
}: Props) => {
  const classes = useStyles();

  const transferTerms = currentItem?.transfer?.transferTerms ?? undefined;
  const transferStorage = currentItem?.transfer?.transferStorage ?? 0;

  if (!transferTerms) return null;

  const isCasting = serviceType === CapaQuotationServiceType.Casting;

  const moldTransferEnumToString = (
    value: CapaRfqPurchaseOrderTransferTermsType
  ) => {
    switch (value) {
      case CapaRfqPurchaseOrderTransferTermsType.TransferAtShip:
        return '납품 후 일정 기간 보관';
      case CapaRfqPurchaseOrderTransferTermsType.StorageAfterShip:
        return '납품 시 이관';
      default:
        return '기타';
    }
  };

  return (
    <>
      <div className={classes.wrapper + ' gutter'}>
        <CustomizedTypography variant="h4" fontWeight="500" gutterBottoms={8}>
          {`${isCasting ? '주형' : '금형'} 이관 조건`}
        </CustomizedTypography>

        <PurchaseOrderViewInfoEntry
          label="이관 조건"
          data={moldTransferEnumToString(
            transferTerms as CapaRfqPurchaseOrderTransferTermsType
          )}
        />
        {transferTerms ===
          CapaRfqPurchaseOrderTransferTermsType.StorageAfterShip && (
          <PurchaseOrderViewInfoEntry
            label="보관 기간"
            data={`${transferStorage}개월`}
          />
        )}
      </div>
      {renderDivider()}
    </>
  );
};

export default PurchaseOrderMoldTransferInfo;
